export default __webpack_public_path__ + "static/media/f1.5089a824.jpg";